// Shared vocabulary for the page editor (Flowmark-style layout, v2.62).

/** Size the canvas previews the page at. Old saved values ('mobile') map to 'phone'. */
export type EditorDevice = 'desktop' | 'tablet' | 'phone';

/** 'edit' = click to select and edit. 'try' = click buttons and fill forms like a visitor (nothing is sent). */
export type CanvasMode = 'edit' | 'try';

/** The inspector's three tabs. Nothing selected shows 'page'; selecting a section shows 'section'. */
export type InspectorTab = 'section' | 'page' | 'ai';

/** Layout widths (px) the canvas renders the page at. Desktop clamps the room it has into [desktopMin, desktopMax] and scales down to fit. */
export const DEVICE_FRAME = { desktopMin: 1024, desktopMax: 1440, tablet: 820, phone: 390 } as const;
